<template>
  <div class="home-search" :class="[deviceType]">
    <div class="search-header">
      <div class="search-dot"></div>
      <div class="search-title">Search by Filter</div>
    </div>
    <div class="search-content">
      <SearchFilter />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchFilter from '@/components/SearchFilter.vue';

export default {
  name: 'HomeSearch',
  components: {
    SearchFilter
  },
  computed: {
    ...mapGetters([
      'deviceType'
    ]),
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}
.el-select__tags {
	max-width: calc(100% - rem(30));
}
.el-tag {
	background-color: rgba(163, 25, 132, 0.1);
	border-color: rgba(163, 25, 132, 0.2);
	color: #a31984;
}
.el-tag .el-tag__close {
	color: #a31984;
}
.el-tag .el-tag__close:hover {
	background-color: #a31984;
	color: #fff;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(163, 25, 132, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #a31984;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-search {
	padding: rem(60) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.search-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.search-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.search-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.detect_deviece_mobile & {
		padding: rem(60) 0;

		.search-header {
			padding: 0 rem(16);
		}
	}

	.search-content {
		padding: 0 rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
	}

	&.mobile {
		.search-content {
			padding: 0 rem(16);
		}
	}
}
</style>